<template>
  <div class="role" vif="model">
    <div class="dates">{{ model.dateRange() }}</div>
    <div class="position">{{ model.data.title }} @ {{ model.data.employer.name }} ({{ model.data.employer.location }})</div>
  </div>
</template>

<script>

export default {
    name  : "Role",
    props : {
        model : {
            type : Object
        }
    }
};

</script>

<style scoped>

.role {
    display:flex;
    flex-wrap:nowrap;
    justify-content:space-between;
    align-items:flex-end;
}

.role > .dates {
    font-weight:bold;
    font-variant:small-caps;
    font-size:14px;
    text-transform:uppercase;
    white-space:nowrap;
}

.role > .position {
    font-size:18px;
    text-align:right;
    padding-left:25px;
}

</style>
